/// <reference path="../../polaris-web-components.d.ts" />
import React, { useState, useEffect, useCallback } from 'react';
import CustomProgressBar from './CustomProgressBar';
import { environment } from '../Services/environment';
import { getShopUrl } from '../Services/CommonServices';
import axios from "axios";
const endpoint = environment.serverUrl;

const exportFilterOptions = [
    { label: 'Full export', value: 'Fullexport' },
    { label: 'Products', value: 'Products' },
    { label: 'Variants', value: 'Variants' },
    { label: 'Product images', value: 'Product_images' },
    { label: 'Variant images', value: 'Variant_images' },
    { label: 'Product metafields', value: 'ProductMetafields' },
    { label: 'Variant metafields', value: 'VariantMetafields' },
];

const ExportStatusCard = ({ exportResult, productProgress, exportConfig, currentRoute, exportType }) => {
    const storeUrl = getShopUrl();
    const [bulkCancelStatus, setBulkCancelStatus] = useState("");
    const [status, setStatus] = useState('running'); // Default to 'running' status
    const [result, setResult] = useState({});
    const [prodCount, setProdCount] = useState(0);
    const [productProgressValue, setProductProgressValue] = useState(0);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [configExport, setConfigExport] = useState({});
    const [loading, setLoading] = useState(true);
    const [downloadError, setDownloadError] = useState(false);
    const [isLinkExpired, setIsLinkExpired] = useState(false);
    const resourceName = {
        singular: 'export',
        plural: 'exports',
    };
    const [activePopover, setActivePopover] = useState(false);
    const togglePopoverActive = useCallback(() => setActivePopover((active) => !active), []);
    
    useEffect(() => {
        console.log("productProgress", productProgress);
        console.log("exportResult", exportResult);
        console.log("exportConfig", exportConfig);
        
        // Set default status to "running" if not set
        if (!status) {
            setStatus("running");
        }
        
        // If exportResult type matches the current route
        if (exportResult?.type?.toLowerCase()?.includes(currentRoute)) {
            if (exportConfig?.status?.toLowerCase() === "running") {
                setResult(exportResult);
                setStatus(exportResult?.status?.toLowerCase() || "running");
            }
            else if (exportResult?.status?.toLowerCase() === "failed") {
                setStatus(exportResult.status?.toLowerCase() || "failed");
                setResult(exportResult);
            }
            else if (exportConfig?.status === "completed") {
                setResult(exportResult);
                setStatus(exportResult?.status?.toLowerCase() || "completed");
            }
            else if (exportConfig?.status === "failed" || exportConfig?.status === "cancelled" || exportConfig?.status === "canceled" || exportConfig?.status === "pending" || exportConfig?.status === "expired") {
                setResult(exportResult);
                setStatus(exportResult?.status?.toLowerCase() || exportConfig?.status?.toLowerCase());
            }
            else {
                // Default to running if no specific status matches
                setResult(exportResult);
                setStatus("running");
            }
        } else {
            // If exportResult doesn't match current route, use exportConfig
            setDownloadError(false);
            setResult(exportConfig || {});
            setStatus(exportConfig?.status?.toLowerCase() || "running");
        }

    }, [exportResult, exportConfig, currentRoute]);

    useEffect(() => {
        setProductProgressValue(productProgress);
    }, [productProgress]);

    useEffect(() => {
        setConfigExport(exportConfig);
    }, [exportConfig]);

    useEffect(() => {
        if (status) {
            setLoading(false);
        }
    }, [status]);

    const handleDownload = async (type) => {
        setDownloadSpinner(true);
        setDownloadError(false);
        setIsLinkExpired(false);
        setActivePopover(false);

        try {
            let api = "";
            if (currentRoute === "product" || currentRoute === "page" || currentRoute === "metaobject" || currentRoute === "order" || currentRoute === "translation" || currentRoute === "definition" || currentRoute === "menu" || currentRoute === "collection") {
                if (exportConfig?.fileUrl) {
                    // Use direct navigation instead of fetch HEAD check to avoid CORS issues
                    // with S3-compatible storage providers (e.g. Cloudflare R2) that may not
                    // have CORS configured. The presigned URL will return an error if expired.
                    const a = document.createElement("a");
                    a.href = exportConfig.fileUrl;
                    a.download = "";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                } else {
                    throw new Error("Link Expired");
                }
            } 
            // else if (currentRoute === "collection") {
            //     api = `/api/Collection/download-previous-export?storeUrl=${storeUrl}&exportType=${type}`;
            // } 
            else if (currentRoute === "customer") {
                api = `/api/Customer/download-previous-export?storeUrl=${storeUrl}&exportType=${type}`;
            }

            if (api) {
                const response = await fetch(`${endpoint}${api}`);

                if (!response.ok) {
                    throw new Error("Link Expired");
                } else {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;

                    const disposition = response.headers.get("Content-Disposition");
                    let filename = storeUrl.replace("myshopify.com", "");

                    if (disposition && disposition.includes("attachment")) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, "");
                        }
                    }

                    if (!filename) {
                        const cleanedStoreUrl = storeUrl.replace("myshopify.com", "");
                        const dateTime = new Date().toISOString().replace(/[:.-]/g, "");
                        filename = `${cleanedStoreUrl}_${dateTime}.xlsx`;
                    }

                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            }
        } catch (error) {
            setDownloadError(true);
        } finally {
            setDownloadSpinner(false);
        }
    };
    

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };
        return new Date(dateString).toLocaleString('en-US', options);
    };

    const cancelBulkOperation = async () => {
    
        try {
            const response = await axios.post(`${endpoint}/api/ProductCustom/bulk-query-cancel?storeUrl=${storeUrl}&action=cancel`);
            
            if (response.status === 200 && response.data) {
                const intervalId = setInterval(async () => {
                    const statusData = await checkBulkOperationStatus();
    
                    if (statusData && (statusData?.status?.toUpperCase()  === 'CANCELED' || statusData?.status?.toUpperCase()  === 'COMPLETED' || statusData?.status?.toUpperCase()  === 'FAILED' || statusData?.status?.toUpperCase()  === 'EXPIRED')) {
                        clearInterval(intervalId);
                        setBulkCancelStatus(statusData.status);
                        // console.log(`Bulk operation ${statusData.status.toLowerCase()} successfully`);
                    } else if (statusData && statusData.status === 'CANCELING') {
                        // console.log("Bulk operation is canceling...");
                    }
                }, 2000);
    
                return response.data;
            } else {
                throw new Error('Empty data');
            }
        } catch (error) {
            // console.error("Error canceling bulk operation", error);
        }
    };
    
    // Separate function to check the current bulk operation status
    const checkBulkOperationStatus = async () => {
        // console.log("Cancelling bulk operation");

        try {
            const response = await axios.post(`${endpoint}/api/ProductCustom/bulk-query-cancel?storeUrl=${storeUrl}&action=cancel`);

            if (response.status === 200 && response.data) {
                return response.data;
            } else {
                throw new Error('Empty data');
            }
        } catch (error) {
            console.error("Error canceling bulk operation", error);
        }
    };

    

    const [activeFilterPopover, setActiveFilterPopover] = useState(false);
    const toggleFilterPopoverActive = useCallback(() => setActiveFilterPopover((active) => !active), []);

    const renderFilterPopover = (vendor, type, filterString) => {
        const filters = filterString ? filterString.trim().split(',') : [];
        const items = [];
        if (vendor && vendor !== "All") items.push(`Vendor: ${vendor}`);
        if (type && type !== "All") items.push(`Type: ${type}`);
        
        filters.forEach(filter => {
            const option = exportFilterOptions.find(opt => opt.value.trim() === filter.trim());
           
            if (option) {
                items.push(option.label);
            }
        });
        const displayText = items.join(', ');
        const truncatedText = displayText.length > 20 ? `${displayText.substring(0, 20)}...` : displayText;
        
        return (
            <>
                <s-tooltip id="filter-tooltip">{displayText}</s-tooltip>
                <s-button variant='tertiary' interestFor={displayText.length > 20 ? "filter-tooltip" : undefined}>
                    {truncatedText}
                </s-button>
            </>
        );
    };

    const exportPopover = (
        <s-popover active={activePopover} onClose={togglePopoverActive}>
            <s-button slot="activator" variant='primary' onClick={togglePopoverActive}>
                Download
            </s-button>
            <s-action-list>
                <s-action-list-item onClick={() => handleDownload('xlsx')}>
                    Export as XLSX
                </s-action-list-item>
                <s-action-list-item onClick={() => handleDownload('csv')}>
                    Export as CSV
                </s-action-list-item>
            </s-action-list>
        </s-popover>
    );
    if (!status || !result) {
        return null;
    }

    const rows = [
        {
            type: (
                <s-stack direction="inline" gap="small">
                    {status === 'running' && <s-spinner size="small" />}
                    <s-text>
                        {
                        currentRoute === "product" 
                        ? configExport
                            ? configExport.vendor === "All" && configExport.type === "All" && !configExport.filter
                                ? "Full export"
                                : renderFilterPopover(configExport.vendor, configExport.type, configExport.filter)
                            : "-"
                        : currentRoute
                        }
                    </s-text>
                </s-stack>
            ),
            createdAt: result?.createdAt ? formatDate(result.createdAt) : '-',
            completedAt: result && result.completedAt !== null && result.completedAt !== 'null' ? formatDate(result.completedAt) : '-',
            progress: (
                <s-stack direction="inline" gap="small" alignment="center">
                    <s-stack direction="inline" gap="small" alignItems="center">
                        <s-text color="subdued" type="regular">
                            {status === 'running' ? productProgress?.toFixed(0) : 100 }%
                        </s-text>
                        <s-box inlineSize="70px">
                            <CustomProgressBar progress={status === 'running' ? productProgress?.toFixed(0) : 100} size="small" />
                        </s-box>
                    </s-stack>
                </s-stack>
            ),
            status: (
                status === 'completed' ? (
                    <s-badge tone='success'>Completed</s-badge>
                ) : status === 'failed' ? (
                    <s-badge tone='critical'>Failed</s-badge>
                ) : (
                    <s-badge tone='warning'>{status}</s-badge>
                )
            ),
            file: (
                status === 'completed' ? (
                    currentRoute === "product" || currentRoute === "page" || currentRoute === "metaobject" || currentRoute === 'order' || currentRoute === "translation" || currentRoute === "definition" || currentRoute === "menu" || currentRoute === "collection" || currentRoute === "customer" ?
                    <s-text color={downloadError ? 'critical' : 'success'}>
                        {!downloadSpinner ? (
                            downloadError ?
                                <s-button variant='primary' onClick={() => handleDownload(null)}>
                                    Failed  retry
                                </s-button> :
                                <s-button variant='primary' onClick={() => handleDownload(null)}>
                                    Download
                                </s-button>
                            
                        ) : (
                            <s-spinner size="small" />
                        )} 
                    </s-text>
                    : (!downloadSpinner ? exportPopover : <s-spinner size="small" />) 
                ) : (<s-text></s-text>)
            )
        },
    ];
    const title =
        currentRoute === "product" && status === "running"
            ? (exportResult?.type === "ProductExport"
                ? (
                    <>
                        Query <s-text color="success">(Products)</s-text>
                    </>
                )
                : (
                    <>
                        Query <s-text color="success">(Images)</s-text>
                    </>
                )
            )
            : "Query";
    
    return (
        <s-box paddingBlockStart="base">
        <s-section padding="none">
            {/* <s-box padding="base">
                <s-grid gridTemplateColumns="1fr auto" gap="none">
                    <s-grid-item>
                        <s-heading>{exportResult?.status?.toLowerCase() === "running" ? 'Export in progress' : 'Last export'}</s-heading>
                    </s-grid-item>
                    <s-grid-item>
                        {exportResult?.status?.toLowerCase() === "running" && (
                            <s-link variant='tertiary'
                                onClick={() => { cancelBulkOperation() }}
                            >
                                Cancel
                            </s-link>
                        )}
                    </s-grid-item>
                </s-grid>
            </s-box> */}

            {/* <s-box padding="base">
                <s-grid gridTemplateColumns="1fr auto" gap="none">
                    <s-grid-item>
                        <s-heading>{exportResult?.status?.toLowerCase() === "running" ? 'Export in progress' : 'Last export'}</s-heading>
                    </s-grid-item>
                    {exportResult?.status?.toLowerCase() === "running" && (
                        <s-grid-item>
                            <s-button variant='tertiary'
                                onClick={() => { cancelBulkOperation() }}
                            >
                                Cancel
                            </s-button>
                        </s-grid-item>
                    )}
                </s-grid>
            </s-box> */}

             <s-box padding="base">
                <s-grid gridTemplateColumns="1fr auto" gap="none">
                    <s-grid-item>
                        <s-heading>{exportResult?.status?.toLowerCase() === "running" ? 'Export in progress' : 'Last export'}</s-heading>
                    </s-grid-item>
                    {exportResult?.status?.toLowerCase() === "running" && (
                    <s-grid-item>
                        <s-link
                                onClick={() => { cancelBulkOperation() }}
                            >
                                Cancel
                            </s-link>
                    </s-grid-item>
                    )}
                </s-grid>
            </s-box>
            <s-table loading={loading}>
                <s-table-header-row>
                    <s-table-header>{title}</s-table-header>
                    {status === 'running' && currentRoute === "product" ? <s-table-header>Progress</s-table-header> : <s-table-header></s-table-header>}
                    <s-table-header>Created at</s-table-header>
                    <s-table-header>Completed at</s-table-header>
                    <s-table-header>Status</s-table-header>
                    <s-table-header>File</s-table-header>
                </s-table-header-row>
                <s-table-body>
                    {rows.map((row, index) => (
                        <s-table-row key={index}>
                            <s-table-cell>{row.type}</s-table-cell>
                            {status === 'running' && currentRoute === "product" ? <s-table-cell>{row.progress}</s-table-cell> : <s-table-cell></s-table-cell>}
                            <s-table-cell>{row.createdAt}</s-table-cell>
                            <s-table-cell>{row.completedAt}</s-table-cell>
                            <s-table-cell>{row.status}</s-table-cell>
                            <s-table-cell>{row.file}</s-table-cell>
                        </s-table-row>
                    ))}
                </s-table-body>
            </s-table>
        </s-section>
        </s-box>
    );
    
};




export default ExportStatusCard;
